import {ROUTES} from '@/utils/constants/routesConstants'
import {msalInstance, loginRequest} from '@/helpers/Auth/authService'

// Function to refresh the token
const refreshToken = async () => {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
        forceRefresh: true,
      })
      //here idToken is used to authenticate APIs
      localStorage.setItem('msalAccessToken', response.idToken)

      // Decode the token to get expiry
      try {
        const decodedToken = JSON.parse(atob(response.idToken.split('.')[1]))
        if (decodedToken.exp) {
          localStorage.setItem('msalTokenExpiry', decodedToken.exp.toString())
        }
      } catch (error) {
        console.error('Error decoding token expiry:', error)
      }

      return response.idToken
    } catch (error) {
      console.error('Error refreshing token:', error)
      window.location.href = ROUTES.SESSION_EXPIRED
    }
  }
  return null
}

export default refreshToken
